import { OverAllPolicyType } from 'src/pages/Policy/utils/types';
import { OverAllPolicyTypeContext } from './context/OverAllPolicyTypeContext';
import { PolicyList } from './PolicyList';

export const OverAllPolicyList = ({
  overAllPolicyType,
}: {
  overAllPolicyType: OverAllPolicyType;
}) => {
  return (
    <OverAllPolicyTypeContext.Provider value={overAllPolicyType}>
      <PolicyList />
    </OverAllPolicyTypeContext.Provider>
  );
};
